import { Carousel, CarouselProps } from "react-responsive-carousel";
import ImageMissing from "assets/placeholders/image-placeholder.jpg";

export interface PoiCarouselProps {
  images: (string | undefined)[];
  selectedItem?: CarouselProps["selectedItem"];
  onClickItem?: CarouselProps["onClickItem"];
  height?: React.ImgHTMLAttributes<HTMLImageElement>["height"];
  width?: React.ImgHTMLAttributes<HTMLImageElement>["width"];
  className?: React.ImgHTMLAttributes<HTMLImageElement>["className"];
}

const PoiCarousel: React.FC<PoiCarouselProps> = ({
  images,
  selectedItem,
  onClickItem,
  height,
  width,
  className,
}) => {
  const showIndicators = images.length > 1;
  return (
    <Carousel
      showArrows
      showStatus={false}
      showIndicators={showIndicators}
      infiniteLoop
      showThumbs={false}
      useKeyboardArrows
      // autoPlay={false}
      // stopOnHover={false}
      swipeable
      // dynamicHeight={false}
      emulateTouch
      // autoFocus={false}
      selectedItem={selectedItem}
      onClickItem={onClickItem}
      className={`PoiCarousel ${showIndicators ? "ShowIndicators" : ""}`}
      children={images.map((imageUrl, index) => (
        <img
          key={`POI_IMAGE_${index}`}
          src={imageUrl || ImageMissing}
          className={className}
          height={height}
          width={width}
          alt={`Scout Point, View ${index + 1}`}
        />
      ))}
      // Prev/Next arrows currently done in CSS
      // SEE: ARROW_ELEMENT
      // renderArrowPrev={}
      // renderArrowNext={}
    />
  );
};

export default PoiCarousel;
